// Géocodage inverse : coordonnées → pays + ville, via BigDataCloud (gratuit, sans clé), comme ZERO SLANG.
// Vie privée : appelé seulement quand le joueur appuie sur « Partager ma position », avec des coordonnées arrondies à ~1 km ;
// rien n'est gardé que le pays et la ville.
import { countryName } from '../core/region.js';

const ENDPOINT = 'https://api.bigdatacloud.net/data/reverse-geocode-client';
const round = (n) => Math.round(n * 100) / 100;

/** { countryCode, country, city? }, ou null si le lieu est inconnu (en mer, zone non couverte). Rejette si le service échoue. */
export async function reverseGeocode(lat, lon, { lang = 'en', fetchImpl = fetch, timeoutMs = 6000 } = {}) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetchImpl(`${ENDPOINT}?latitude=${round(lat)}&longitude=${round(lon)}&localityLanguage=${lang}`, { signal: ctrl.signal });
    if (!res.ok) throw new Error(`geocoding ${res.status}`);
    const data = await res.json();
    if (!/^[A-Za-z]{2}$/.test(data.countryCode || '')) return null;
    const place = { countryCode: data.countryCode.toUpperCase(), country: countryName(data.countryCode, lang, data.countryName) };
    const city = (data.city || data.locality || '').trim();
    if (city) place.city = city;
    return place;
  } finally {
    clearTimeout(timer);
  }
}
